import React, { useState } from "react";
import PropTypes from "prop-types";
import { SET_USER_UID } from "../Redux/actions";
import { auth } from "../firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// --- Friendly Error Messages Mapping ---
const firebaseErrorMessages = {
  "auth/invalid-credential": "Invalid email, username, or password.",
  "auth/user-not-found": "No account found with this email or username.",
  "auth/wrong-password": "Incorrect password. Please try again.",
  "auth/too-many-requests":
    "Too many failed login attempts. Please try again later.",
  "auth/network-request-failed": "Network error. Please check your connection.",
  "auth/popup-closed-by-user": "Google sign-in was cancelled.",
  // Add more as needed
};
// --- End Error Mapping ---

// --- Identifier Pipeline ---
function transformToEmail(identifier) {
  const emailRegex = /^([a-z0-9._-]+)@([a-z0-9.-]+\.[a-z]{2,})$/;
  if (emailRegex.test(identifier)) {
    return identifier;
  }
  return `${identifier}@dummy.com`;
}

function prepareIdentifier(input) {
  const normalized = input.trim().toLowerCase();
  return transformToEmail(normalized);
}
// --- End Identifier Pipeline ---

export default function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginerror, setLoginerror] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginerror("");
    try {
      let preparedIdentifier;
      try {
        preparedIdentifier = prepareIdentifier(email);
      } catch (err) {
        setLoginerror(err.message || "Invalid login identifier.");
        return;
      }

      const userCredential = await signInWithEmailAndPassword(
        auth,
        preparedIdentifier,
        password
      );
      const user = userCredential.user;

      // Store only non-sensitive user info
      window.localStorage.setItem("authCode", user.uid);
      window.localStorage.setItem("name", user.displayName || user.email || "");
      window.localStorage.setItem("userId", user.uid);

      props.setloggeduser(user.displayName || user.email);

      // Set UID in Redux
      dispatch({ type: SET_USER_UID, payload: user.uid });

      navigate("/");
    } catch (error) {
      const friendlyMessage =
        firebaseErrorMessages[error.code] ||
        "Login failed. Please check your credentials and try again.";
      setLoginerror(friendlyMessage);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoginerror("");
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Store only non-sensitive user info
      window.localStorage.setItem("authCode", user.uid);
      window.localStorage.setItem("name", user.displayName || user.email || "");
      window.localStorage.setItem("userId", user.uid);

      props.setloggeduser(user.displayName || user.email);

      // Set UID in Redux
      dispatch({ type: SET_USER_UID, payload: user.uid });

      navigate("/");
    } catch (error) {
      const friendlyMessage =
        firebaseErrorMessages[error.code] ||
        "Google sign-in failed. Please try again.";
      setLoginerror(friendlyMessage);
    }
  };

  return (
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div style={{ width: "350px", marginTop: "100px" }}>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="loginEmail" className="form-label">
              Email or Username
            </label>
            <input
              type="text"
              className="form-control"
              id="loginEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="loginPassword" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="loginPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <div id="showMessage" className="form-text mb-2 text-danger">
            {loginerror}
          </div>

          <div className="mb-3">
            <Link to="/register">Create an account.</Link>
          </div>

          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>

        {/* Divider with "or" */}
        <div className="d-flex align-items-center my-4">
          <hr className="flex-grow-1" />
          <span className="mx-2 text-muted">or</span>
          <hr className="flex-grow-1" />
        </div>

        {/* Google Sign-In Button */}
        <button
          type="button"
          className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center"
          onClick={handleGoogleSignIn}
          style={{ height: "42px" }}
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google Logo"
            style={{ width: 20, marginRight: "10px" }}
          />
          Sign in with Google
        </button>
      </div>
    </div>
  );
}

Login.propTypes = {
  setloggeduser: PropTypes.func.isRequired,
};
